export var NotificationProviderScope;
(function (NotificationProviderScope) {
    NotificationProviderScope["Global"] = "global";
    NotificationProviderScope["MyTrumpf"] = "mytrumpf";
})(NotificationProviderScope || (NotificationProviderScope = {}));
export var UxNotificationSeverityEnum;
(function (UxNotificationSeverityEnum) {
    UxNotificationSeverityEnum["Information"] = "Information";
    UxNotificationSeverityEnum["Warning"] = "Warning";
    UxNotificationSeverityEnum["Error"] = "Error";
})(UxNotificationSeverityEnum || (UxNotificationSeverityEnum = {}));
export var UxNotificationStatusEnum;
(function (UxNotificationStatusEnum) {
    UxNotificationStatusEnum["Open"] = "open";
    UxNotificationStatusEnum["Closed"] = "closed";
    UxNotificationStatusEnum["Committed"] = "committed";
})(UxNotificationStatusEnum || (UxNotificationStatusEnum = {}));
//# sourceMappingURL=interface.js.map
